import { useMutation } from "react-query";
import http from "infra/http";

function useDesconciliarExtrato() {
  return useMutation(
    (extratoId: string) => {
      return http.post(`/v1/extrato-bancario/${extratoId}/desconciliar`);
    },
    { retry: false }
  );
}

export default useDesconciliarExtrato;
